/** DESIGN.md §9.1 Spinner. Rotates via `transform` only (§5.3) so it never touches layout. */
export function Spinner({
  size = 20,
  label,
}: {
  size?: number;
  /** The `role="status"` accessible name. `ui/` stays dictionary-free (see `SearchField.tsx`'s
   * rule), so a caller that wants this spinner announced passes `t('common.loading')`.
   *
   * MVP-357: omitting it now makes the spinner DECORATIVE rather than falling back to an English
   * "Loading". Both readings of the old default were wrong: inside `Button`/`IconButton` — the only
   * two callers that omit it — the control already carries its own accessible name, so a nested
   * live region announcing "Loading" was noise; and everywhere else the word would have been read
   * out in English on a Thai screen. Every standalone spinner in the app passes a label. */
  label?: string;
}) {
  return (
    <svg
      className="spinner"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      role={label === undefined ? undefined : 'status'}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
